import './alert.css'

function Success({hide}) {
    return (
        <div id='alert-background' onClick={() => hide()}>
            <div className='alert-modal' onClick={() => hide()}>
                <div className='title'>Success</div>
                <div className='content'>Detaliile de contact au fost trimise cu succes. Vom reveni in curand cu un email pe adresa primita cu urmatorii pasi.<br/><br/>Multumim pentru interes</div>
                <div className='horizontal-space-30' />
                <div className='horizontal-space-30' />
            </div>
        </div>
    )
}

function Failed({hide, content}) {
    return (
        <div id='alert-background' onClick={() => hide()}>
            <div className='alert-modal bad' onClick={() => hide()}>
                <div className='title'>Failed</div>
                <div className='content'>{content}</div>
                <div className='horizontal-space-30' />
                <div className='horizontal-space-30' />
            </div>
        </div>
    )
}

export {Success, Failed};